import { Box, styled } from '@qwealth/qcore';

export const UploaderWithoutPreview = styled(Box)`
  .wrapper:not(.wrapper--uploader-min-width) {
    display: none;
  }
`;
